import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

interface Params {
  bookingId: string;
  amendmentId: string;
}

const acceptAmendment = async (
  { bookingId, amendmentId }: Params,
  options: Options = {},
): Promise<SelfServiceAPI.CreateCancellation.Response> => {
  try {
    const { data } = await api.post(`/bookings/${bookingId}/amendments/${amendmentId}/accept`);
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/amendments/${amendmentId}/accept`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default acceptAmendment;
